export default {
    type: 'numeric',
    format: {
        decimals: 0,
        min: 0,
    },
    default: {
        logic: 'min',
        period: 'all'
    },
    setting: {
        logic: ['match', 'min', 'max', 'range', 'tolerance'],
        period: ['all', 'specific']
    },
    link: {
        'date.played': function(rule) {

            return (rule.setting) ? rule.setting.period === 'specific' : false

        }
    },
    usage: {
        owners: ['user'],
        results: ['collection','play','rating','game']
    },
    lang: {
        name: 'Total Plays',
        category: ['User', 'Plays'],
        description: 'Number of plays across all-time or a specific time period.',
        unit: 'play'
    },
    rules: {
        linked: [],
        legacy: ['threshold.plays']
    }
}